export function trackClientEvent(payload: { name: string; params?: Record<string, any>; userId?: string; clientId?: string; userEmail?: string }) {
  try {
    //console.log('[analyticsClient] Tracking event:', payload);
    if (typeof navigator !== 'undefined' && 'sendBeacon' in navigator) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      (navigator as any).sendBeacon('/api/analytics/track', blob);
      return;
    }
    if (typeof fetch !== 'undefined') {
      fetch('/api/analytics/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => {});
    }
  } catch {}
}


